import * as Types from '../generated.types'

import { FinchConnectionDetailFragmentDoc } from './FinchConnectionFragment_gen'
import { WorkLocationFragmentDoc } from './WorkLocationFragment_gen'
import { AddressFragmentDoc } from './AddressFragment_gen'
import { TelephoneFragmentDoc } from './TelephoneFragment_gen'
import { PaymentCardFragmentDoc } from './PaymentCardFragment_gen'
import { ErrorFragmentDoc } from './ErrorFragment_gen'
import { BankingAccountFragmentDoc } from './BankingAccountFragment_gen'
export type OrganizationDetailFragment = {
  __typename: 'Organization'
  id: number
  name?: string | null
  legalName?: string | null
  contractSignedOn?: string | null
  launchDate?: string | null
  isOnboarded?: boolean | null
  ein?: string | null
  tel?: string | null
  websiteUrl?: string | null
  businessStructure?: Types.OrganizationBusinessStructure | null
  mcc?: { __typename?: 'MCC'; mcc: number; label: string } | null
  address?: {
    __typename?: 'AddressDisplay'
    line1?: string | null
    line2?: string | null
    cityName?: string | null
    stateCode?: string | null
    zipcode?: string | null
    isVerified: boolean
    verificationStatus?: Types.AddressVerificationStatus | null
  } | null
  logo?: { __typename?: 'Image'; url?: string | null; thumbnailUrl?: string | null } | null
  aliceCardProgram: {
    __typename?: 'AliceCardProgram'
    kycStatus: Types.AliceCardKycStatus
    hasFundingConnected: boolean
    cardIssuingStatus: Types.AliceCardIssuingStatus
    hasUnifiedBanking?: boolean | null
    employeeFundingCount: number
    perEmployeeFundingAmount: number
    reserveAmount: number
    companyAccount?: {
      __typename?: 'StripeCompanyAccount'
      id: number
      accountStatus: Types.StripeCompanyAccountStatusEnum
      stripeConnectedAccountId?: string | null
      stripeFinancialAccountId?: string | null
      requirementsPendingVerification: Array<string>
      currentlyDueRequirements: Array<string>
      companyRepresentative?: {
        __typename?: 'User'
        id: number
        firstName?: string | null
        lastName?: string | null
        email?: string | null
        birthdate?: string | null
        ssnLast4?: string | null
        tel?: {
          __typename?: 'Telephone'
          nationalNumber: string
          isSmsConfirmed?: boolean | null
          isConfirmationCodeSent?: boolean | null
        } | null
        address?: {
          __typename?: 'AddressDisplay'
          line1?: string | null
          line2?: string | null
          cityName?: string | null
          stateCode?: string | null
          zipcode?: string | null
        } | null
      } | null
    } | null
  }
  aliceCardFunding: {
    __typename?: 'AliceCardFunding'
    status: Types.AliceCardFundingStatus
    paymentMethodConnections?: Array<{
      __typename?: 'PaymentMethodConnection'
      id?: number | null
      isCurrent: boolean
      isActive: boolean
      paymentMethod: {
        __typename?: 'PaymentMethod'
        id?: number | null
        last4?: string | null
        descriptor: string
        status: Types.PaymentMethodStatus
        stripeSystemId?: string | null
      }
    }> | null
    availablePaymentMethods?: Array<{
      __typename?: 'PaymentMethod'
      id?: number | null
      last4?: string | null
      descriptor: string
      status: Types.PaymentMethodStatus
      stripeSystemId?: string | null
    }> | null
  }
  payrollConnection: {
    __typename?: 'PayrollConnection'
    payrollInstructionsCompletedAt?: string | null
    payrollConnectedAt?: string | null
    isFinchConnectEnabled: boolean
    finchConnections: Array<{
      __typename: 'FinchConnection'
      id: number
      sessionId?: string | null
      displayLabel?: string | null
      isActive: boolean
      status?: Types.FinchConnectionStatus | null
      hasAuthenticatedEver: boolean
    }>
    payrollPlatform?: {
      __typename?: 'PayrollPlatform'
      id: number
      name: string
      code: string
      permitsAdminReports: boolean
    } | null
  }
  defaultPayrollPlatform?: { __typename?: 'PayrollPlatform'; id: number; name: string; code: string } | null
  billing?: {
    __typename?: 'Billing'
    hasUnifiedBilling: boolean
    hasBillingConnected: boolean
    billingWorkspace: Types.BillingWorkspace
    billingSource?:
      | {
          __typename: 'BankingAccount'
          id: number
          billingSystemId?: string | null
          name?: string | null
          cardType?: Types.BankCardType | null
          accountType?: Types.BankingAccountType | null
          platform: Types.BankingAccountPlatform
          accountLast4?: string | null
          error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
        }
      | {
          __typename: 'PaymentCard'
          id: number
          billingSystemId?: string | null
          brand: string
          expMonth: number
          expYear: number
          last4: string
          error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
        }
      | null
  } | null
  employers: Array<{
    __typename: 'Employer'
    id: number
    name?: string | null
    marketingFriendlyName?: string | null
    inviteCode: string
    finchConnection?: {
      __typename: 'FinchConnection'
      id: number
      sessionId?: string | null
      displayLabel?: string | null
      isActive: boolean
      status?: Types.FinchConnectionStatus | null
      hasAuthenticatedEver: boolean
    } | null
    aliceCardFunding: {
      __typename?: 'AliceCardFunding'
      status: Types.AliceCardFundingStatus
      paymentMethodConnections?: Array<{
        __typename?: 'PaymentMethodConnection'
        id?: number | null
        isCurrent: boolean
        isActive: boolean
        paymentMethod: {
          __typename?: 'PaymentMethod'
          id?: number | null
          last4?: string | null
          descriptor: string
          status: Types.PaymentMethodStatus
          stripeSystemId?: string | null
        }
      }> | null
      availablePaymentMethods?: Array<{
        __typename?: 'PaymentMethod'
        id?: number | null
        last4?: string | null
        descriptor: string
        status: Types.PaymentMethodStatus
        stripeSystemId?: string | null
      }> | null
    }
    billing?: {
      __typename?: 'Billing'
      hasUnifiedBilling: boolean
      hasBillingConnected: boolean
      billingWorkspace: Types.BillingWorkspace
      billingSource?:
        | {
            __typename: 'BankingAccount'
            id: number
            billingSystemId?: string | null
            name?: string | null
            cardType?: Types.BankCardType | null
            accountType?: Types.BankingAccountType | null
            platform: Types.BankingAccountPlatform
            accountLast4?: string | null
            error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
          }
        | {
            __typename: 'PaymentCard'
            id: number
            billingSystemId?: string | null
            brand: string
            expMonth: number
            expYear: number
            last4: string
            error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
          }
        | null
    } | null
    employees: {
      __typename?: 'EmployeeConnection'
      reachableCount: number
      totalCount: number
      enrolledCount: number
      totalDeductions: number
      totalSavings: number
    }
  } | null>
  workLocations: Array<{
    __typename?: 'WorkLocation'
    id: number
    name: string
    latitude?: number | null
    longitude?: number | null
    logo?: { __typename?: 'Image'; url?: string | null; thumbnailUrl?: string | null } | null
    enrollmentMaterials?: { __typename?: 'EnrollmentMaterials'; zippedMaterialsUrl?: string | null } | null
    employersInfo?: Array<{ __typename?: 'Employer'; id: number; name?: string | null }> | null
    address?: {
      __typename?: 'AddressDisplay'
      isVerified: boolean
      isMailing: boolean
      line1?: string | null
      line2?: string | null
      cityName?: string | null
      stateCode?: string | null
      zipcode?: string | null
    } | null
    preshiftEvents: Array<{
      __typename?: 'PreshiftEvent'
      id: number
      scheduledAt?: string | null
      inviteeName?: string | null
      inviteeEmail?: string | null
      createdAt: string
    }>
  } | null>
  employees: {
    __typename?: 'EmployeeConnection'
    reachableCount: number
    totalCount: number
    enrolledCount: number
    totalDeductions: number
    totalSavings: number
  }
  onboardingWorkflow?: {
    __typename?: 'OnboardingWorkflow'
    id: number
    status: Types.OnboardingStatus
    activityLog: Array<{
      __typename?: 'OnboardingLogMessage'
      what: string
      when: string
      stepType: Types.OnboardingStepType
      resourceUrl?: string | null
      who?: { __typename?: 'OnboardingLogUser'; id: number; name: string; email: string } | null
    }>
    steps: Array<{
      __typename?: 'OnboardingStep'
      id: number
      stepType: Types.OnboardingStepType
      status: Types.OnboardingStatus
      assignee: {
        __typename?: 'User'
        id: number
        firstName?: string | null
        lastName?: string | null
        email?: string | null
      }
      tasks: Array<{
        __typename?: 'OnboardingStepTask'
        id: number
        taskType: string
        status: Types.OnboardingStatus
      }>
    }>
  } | null
  reports: {
    __typename?: 'OrganizationReports'
    aliceCardReconciliation: {
      __typename?: 'OrganizationReport'
      id: string
      description: string
      downloadUrl: string
      title: string
    }
    financial: {
      __typename?: 'OrganizationReport'
      id: string
      description: string
      downloadUrl: string
      title: string
    }
    invoices: {
      __typename?: 'OrganizationReport'
      id: string
      description: string
      downloadUrl: string
      title: string
    }
    payPeriods: {
      __typename?: 'OrganizationReport'
      id: string
      description: string
      downloadUrl: string
      title: string
    }
  }
}

export type EmployerSummaryFragment = {
  __typename: 'Employer'
  id: number
  name?: string | null
  marketingFriendlyName?: string | null
  inviteCode: string
  finchConnection?: {
    __typename: 'FinchConnection'
    id: number
    sessionId?: string | null
    displayLabel?: string | null
    isActive: boolean
    status?: Types.FinchConnectionStatus | null
    hasAuthenticatedEver: boolean
  } | null
  aliceCardFunding: {
    __typename?: 'AliceCardFunding'
    status: Types.AliceCardFundingStatus
    paymentMethodConnections?: Array<{
      __typename?: 'PaymentMethodConnection'
      id?: number | null
      isCurrent: boolean
      isActive: boolean
      paymentMethod: {
        __typename?: 'PaymentMethod'
        id?: number | null
        last4?: string | null
        descriptor: string
        status: Types.PaymentMethodStatus
        stripeSystemId?: string | null
      }
    }> | null
    availablePaymentMethods?: Array<{
      __typename?: 'PaymentMethod'
      id?: number | null
      last4?: string | null
      descriptor: string
      status: Types.PaymentMethodStatus
      stripeSystemId?: string | null
    }> | null
  }
  billing?: {
    __typename?: 'Billing'
    hasUnifiedBilling: boolean
    hasBillingConnected: boolean
    billingWorkspace: Types.BillingWorkspace
    billingSource?:
      | {
          __typename: 'BankingAccount'
          id: number
          billingSystemId?: string | null
          name?: string | null
          cardType?: Types.BankCardType | null
          accountType?: Types.BankingAccountType | null
          platform: Types.BankingAccountPlatform
          accountLast4?: string | null
          error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
        }
      | {
          __typename: 'PaymentCard'
          id: number
          billingSystemId?: string | null
          brand: string
          expMonth: number
          expYear: number
          last4: string
          error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
        }
      | null
  } | null
  employees: {
    __typename?: 'EmployeeConnection'
    reachableCount: number
    totalCount: number
    enrolledCount: number
    totalDeductions: number
    totalSavings: number
  }
}

export type AliceCardProgramFragment = {
  __typename?: 'AliceCardProgram'
  kycStatus: Types.AliceCardKycStatus
  hasFundingConnected: boolean
  cardIssuingStatus: Types.AliceCardIssuingStatus
  hasUnifiedBanking?: boolean | null
  employeeFundingCount: number
  perEmployeeFundingAmount: number
  reserveAmount: number
  companyAccount?: {
    __typename?: 'StripeCompanyAccount'
    id: number
    accountStatus: Types.StripeCompanyAccountStatusEnum
    stripeConnectedAccountId?: string | null
    stripeFinancialAccountId?: string | null
    requirementsPendingVerification: Array<string>
    currentlyDueRequirements: Array<string>
    companyRepresentative?: {
      __typename?: 'User'
      id: number
      firstName?: string | null
      lastName?: string | null
      email?: string | null
      birthdate?: string | null
      ssnLast4?: string | null
      tel?: {
        __typename?: 'Telephone'
        nationalNumber: string
        isSmsConfirmed?: boolean | null
        isConfirmationCodeSent?: boolean | null
      } | null
      address?: {
        __typename?: 'AddressDisplay'
        line1?: string | null
        line2?: string | null
        cityName?: string | null
        stateCode?: string | null
        zipcode?: string | null
      } | null
    } | null
  } | null
}

export type AliceCardFundingFragment = {
  __typename?: 'AliceCardFunding'
  status: Types.AliceCardFundingStatus
  paymentMethodConnections?: Array<{
    __typename?: 'PaymentMethodConnection'
    id?: number | null
    isCurrent: boolean
    isActive: boolean
    paymentMethod: {
      __typename?: 'PaymentMethod'
      id?: number | null
      last4?: string | null
      descriptor: string
      status: Types.PaymentMethodStatus
      stripeSystemId?: string | null
    }
  }> | null
  availablePaymentMethods?: Array<{
    __typename?: 'PaymentMethod'
    id?: number | null
    last4?: string | null
    descriptor: string
    status: Types.PaymentMethodStatus
    stripeSystemId?: string | null
  }> | null
}

export type PaymentMethodConnectionFragment = {
  __typename?: 'PaymentMethodConnection'
  id?: number | null
  isCurrent: boolean
  isActive: boolean
  paymentMethod: {
    __typename?: 'PaymentMethod'
    id?: number | null
    last4?: string | null
    descriptor: string
    status: Types.PaymentMethodStatus
    stripeSystemId?: string | null
  }
}

export type PaymentMethodFragment = {
  __typename?: 'PaymentMethod'
  id?: number | null
  last4?: string | null
  descriptor: string
  status: Types.PaymentMethodStatus
  stripeSystemId?: string | null
}

export type BillingSource_BankingAccount_Fragment = {
  __typename: 'BankingAccount'
  id: number
  billingSystemId?: string | null
  name?: string | null
  cardType?: Types.BankCardType | null
  accountType?: Types.BankingAccountType | null
  platform: Types.BankingAccountPlatform
  accountLast4?: string | null
  error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
}

export type BillingSource_PaymentCard_Fragment = {
  __typename: 'PaymentCard'
  id: number
  billingSystemId?: string | null
  brand: string
  expMonth: number
  expYear: number
  last4: string
  error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
}

export type BillingSourceFragment = BillingSource_BankingAccount_Fragment | BillingSource_PaymentCard_Fragment

export type OnboardingWorkflowFragment = {
  __typename?: 'OnboardingWorkflow'
  id: number
  status: Types.OnboardingStatus
  activityLog: Array<{
    __typename?: 'OnboardingLogMessage'
    what: string
    when: string
    stepType: Types.OnboardingStepType
    resourceUrl?: string | null
    who?: { __typename?: 'OnboardingLogUser'; id: number; name: string; email: string } | null
  }>
  steps: Array<{
    __typename?: 'OnboardingStep'
    id: number
    stepType: Types.OnboardingStepType
    status: Types.OnboardingStatus
    assignee: {
      __typename?: 'User'
      id: number
      firstName?: string | null
      lastName?: string | null
      email?: string | null
    }
    tasks: Array<{
      __typename?: 'OnboardingStepTask'
      id: number
      taskType: string
      status: Types.OnboardingStatus
    }>
  }>
}

export const AliceCardProgramFragmentDoc = `
    fragment AliceCardProgram on AliceCardProgram {
  kycStatus
  hasFundingConnected
  cardIssuingStatus
  hasUnifiedBanking
  employeeFundingCount
  perEmployeeFundingAmount
  reserveAmount
  companyAccount {
    id
    accountStatus
    stripeConnectedAccountId
    stripeFinancialAccountId
    requirementsPendingVerification
    currentlyDueRequirements
    companyRepresentative {
      id
      firstName
      lastName
      email
      birthdate
      ssnLast4
      tel {
        ...Telephone
      }
      address {
        line1
        line2
        cityName
        stateCode
        zipcode
      }
    }
  }
}
    `
export const PaymentMethodFragmentDoc = `
    fragment PaymentMethod on PaymentMethod {
  id
  last4
  descriptor
  status
  stripeSystemId
}
    `
export const PaymentMethodConnectionFragmentDoc = `
    fragment PaymentMethodConnection on PaymentMethodConnection {
  id
  isCurrent
  isActive
  paymentMethod {
    ...PaymentMethod
  }
}
    `
export const AliceCardFundingFragmentDoc = `
    fragment AliceCardFunding on AliceCardFunding {
  status
  paymentMethodConnections {
    ...PaymentMethodConnection
  }
  availablePaymentMethods {
    ...PaymentMethod
  }
}
    `
export const BillingSourceFragmentDoc = `
    fragment BillingSource on BillingSource {
  __typename
  ... on PaymentCard {
    ...PaymentCard
  }
  ... on BankingAccount {
    ...BankingAccount
  }
}
    `
export const EmployerSummaryFragmentDoc = `
    fragment EmployerSummary on Employer {
  __typename
  id
  name
  marketingFriendlyName
  inviteCode
  finchConnection {
    ...FinchConnectionDetail
  }
  aliceCardFunding {
    ...AliceCardFunding
  }
  billing {
    hasUnifiedBilling
    hasBillingConnected
    billingWorkspace
    billingSource {
      ...BillingSource
    }
  }
  employees {
    reachableCount
    totalCount
    enrolledCount
    totalDeductions
    totalSavings
  }
}
    `
export const OnboardingWorkflowFragmentDoc = `
    fragment OnboardingWorkflow on OnboardingWorkflow {
  id
  status
  activityLog {
    what
    when
    stepType
    resourceUrl
    who {
      id
      name
      email
    }
  }
  steps {
    id
    stepType
    status
    assignee {
      id
      firstName
      lastName
      email
    }
    tasks {
      id
      taskType
      status
    }
  }
}
    `
export const OrganizationDetailFragmentDoc = `
    fragment OrganizationDetail on Organization {
  __typename
  id
  name
  legalName
  contractSignedOn
  launchDate
  isOnboarded
  mcc {
    mcc
    label
  }
  ein
  tel
  websiteUrl
  businessStructure
  address {
    line1
    line2
    cityName
    stateCode
    zipcode
    isVerified
    verificationStatus
  }
  logo {
    url
    thumbnailUrl
  }
  aliceCardProgram {
    ...AliceCardProgram
  }
  aliceCardFunding {
    ...AliceCardFunding
  }
  payrollConnection {
    payrollInstructionsCompletedAt
    payrollConnectedAt
    isFinchConnectEnabled
    finchConnections {
      ...FinchConnectionDetail
    }
    payrollPlatform {
      id
      name
      code
      permitsAdminReports
    }
  }
  defaultPayrollPlatform {
    id
    name
    code
  }
  billing {
    hasUnifiedBilling
    hasBillingConnected
    billingWorkspace
    billingSource {
      ...BillingSource
    }
  }
  employers {
    ...EmployerSummary
  }
  workLocations {
    ...WorkLocation
  }
  employees {
    reachableCount
    totalCount
    enrolledCount
    totalDeductions
    totalSavings
  }
  onboardingWorkflow {
    ...OnboardingWorkflow
  }
  reports {
    aliceCardReconciliation {
      id
      description
      downloadUrl
      title
    }
    financial {
      id
      description
      downloadUrl
      title
    }
    invoices {
      id
      description
      downloadUrl
      title
    }
    payPeriods {
      id
      description
      downloadUrl
      title
    }
  }
}
    `
